import { render, staticRenderFns } from "./InspectOrganizeEdit.vue?vue&type=template&id=4432f548&scoped=true"
import script from "./InspectOrganizeEdit.vue?vue&type=script&lang=js"
export * from "./InspectOrganizeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4432f548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4432f548')) {
      api.createRecord('4432f548', component.options)
    } else {
      api.reload('4432f548', component.options)
    }
    module.hot.accept("./InspectOrganizeEdit.vue?vue&type=template&id=4432f548&scoped=true", function () {
      api.rerender('4432f548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/inspectOrganize/InspectOrganizeEdit.vue"
export default component.exports